<template>
  <div>
    <h3 class="text-center mb-4 mt-4" v-if="!isBackend">{{ $t('scope.ce_tech_support') }}</h3>
    <page-header v-else :title="$t('scope.ce_tech_support')" />
    <div v-if="!isBackend">
      <div class="steps-container">
        <a-steps :current="3" label-placement="vertical">
          <a-step title="购买" :description="'按次购买' + $t('scope.technical_consulting') + '服务'" />
          <a-step :title="$t('scope.technical_consulting')" description="扫描二维码进入专属企业微信群进行问题咨询" />
          <a-step :title="$t('scope.remote_assistance') + '(可选)'" :description="'如果问题仅通过' + $t('scope.technical_consulting') + '无法解决，可购买升级为' + $t('scope.remote_assistance') + '服务'" />
          <a-step title="解决" description="问题解决，完成服务。7个自然日后专属企业微信群解散" />
        </a-steps>
      </div>
      <div class="price-info">
        <div>{{ $t('scope.technical_consulting') }}服务价格为{{ consult_origin_rate }}元/次，活动期间折扣价为<span class="discount-price">{{ consult_rate }}元/次</span>。</div>
        <div>{{ $t('scope.remote_assistance') }}服务升级价格为{{ remote_origin_rate }}元/次，活动期间折扣价为<span class="discount-price">{{ remote_rate }}元/次</span>。</div>
        <div v-if="consult_coupon_amount && remote_coupon_amount">完成 <a href="/account" target="_blank">个人实名认证 </a> 和 <a href="/account" target="_blank">企业实名认证</a> 可获得 1. <span class="discount-price">{{ consult_coupon_amount }}元优惠券</span>一张，可用于购买{{ $t('scope.technical_consulting') }}服务；2. <span class="discount-price">{{ remote_coupon_amount }}元优惠券</span>一张，可用于购买{{ $t('scope.remote_assistance') }}服务。两种优惠券均可叠加当前活动折扣使用。</div>
      </div>
    </div>
    <page-body>
      <tech-support-list :id="listId" :is-backend="isBackend" />
    </page-body>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TechSupportList from './components/List'

export default {
  name: 'AccountTechSupport',
  components: {
    TechSupportList,
  },
  data () {
    return {
      listId: 'techSupportList',
    }
  },
  computed: {
    ...mapState('app', {
      consult_origin_rate: state => state.customerCapability.consult_origin_rate,
      consult_rate: state => state.customerCapability.consult_rate,
      remote_origin_rate: state => state.customerCapability.remote_origin_rate,
      consult_coupon_amount: state => state.customerCapability.consult_coupon_amount,
      remote_coupon_amount: state => state.customerCapability.remote_coupon_amount,
      remote_rate: state => state.customerCapability.remote_rate,
    }),
    isBackend () {
      return this.$route.path.includes('/backend-tech-support')
    },
  },
}
</script>

<style lang="scss" scoped>
.discount-price {
  color: #ff4d4f;
  font-weight: bold;
}
.price-info {
  margin-bottom: 10px;
  padding: 16px;
}
.steps-container {
  margin-bottom: 20px;
  padding: 16px;
  ::v-deep .ant-steps-item-content {
    text-align: center;
    width: auto !important;
    max-width: 140px;
    white-space: normal;
  }
  ::v-deep .ant-steps-item-title {
    white-space: normal;
    line-height: 1.4;
    padding-right: 0 !important;
  }
  ::v-deep .ant-steps-item-description {
    white-space: normal;
    max-width: 140px;
    text-align: center;
    line-height: 1.4;
    padding-right: 0 !important;
  }
}
</style>
